module.exports = __webpack_public_path__ + "img/anquanyanzheng.5911bd3c.png";